import React from "react";
import { Routes, Route, NavLink } from "react-router-dom";
import LoadEntryReport from "./reports/LoadEntryReport";
import EmployeePayoutReport from "./reports/EmployeePayoutReport";
import InvoiceReport from "./reports/InvoiceReport";

export default function Reports() {
  return (
    <>
      <h2>Reports</h2>

      <div className="mb-3">
        <NavLink to="/reports/load-entry" className="btn btn-outline-primary me-2">
          Load Entry
        </NavLink>

        <NavLink to="/reports/employee-payout" className="btn btn-outline-primary me-2">
          Employee Payout
        </NavLink>

        <NavLink to="/reports/invoice" className="btn btn-outline-primary">
          Invoice
        </NavLink>
      </div>

      <Routes>
        <Route path="load-entry" element={<LoadEntryReport />} />
        <Route path="employee-payout" element={<EmployeePayoutReport />} />
        <Route path="invoice" element={<InvoiceReport />} />
      </Routes>
    </>
  );
}
